var OCS = OCS || {};
OCS.Worker = OCS.Worker || {};
OCS.Worker.Subscriptions = OCS.Worker.Subscriptions || {};
OCS.Worker.Classes = OCS.Worker.Classes || {};
OCS.Worker.Classes.SubscriptionObj = new Class({
    Implements: [Options, Events],
    class_type: 'SubscriptionObj',
    options: {
        channel_name: null,
        dataset: '',
        debug: false
    },
    sub_id: null,
    listeners: 0,
    initialize: function (op) {
        if (!op || !op.channel_name) {
            return;
        }
        if (OCS.Worker.Subscriptions[op.channel_name]) {
            return OCS.Worker.Subscriptions[op.channel_name];
        }
        this.setOptions(op);
        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug("data_worker - SubscriptionObj: Subscription object being created on channel " + this.options.channel_name + ".");
        }
        OCS.Worker.Subscriptions[op.channel_name] = this;
    },

    add_listener: function () {
        if (this.listeners === 0) {
            this.subscribe();
        }
        this.listeners++;

    },
    remove_listener: function () {
        this.listeners--;
        if (this.listeners <= 0) {
            this.unsubscribe();
            this.listeners = 0;
        }
    },
    subscribe: function () {
        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug("data_worker - SubscriptionObj: subscribe method fired on channel " + this.options.channel_name + ".");
        }
        if (!this.sub_id) {
            this.fireEvent('send_to_xmpp', ['xmpp.pubsub.subscribe', this.options.channel_name, this.on_subscribe.bind(this)]);
        }
    },
    unsubscribe: function () {
        /* istanbul ignore if */
        if (this.options.debug) {
            console.debug("data_worker - SubscriptionObj: unsubscribe method fired on channel " + this.options.channel_name + ".");
        }
        if (this.sub_id) {
            this.fireEvent('send_to_xmpp', ['xmpp.pubsub.unsubscribe', this.options.channel_name, this.on_unsubscribe.bind(this)]);
        }
    },

    on_subscribe: function (error, data) {
        if (!error && data && data.subscription === "subscribed") {
            this.sub_id = data.id;
        }
    },
    on_unsubscribe: function (error, data) {
        this.sub_id = null;
    },
    set_debug: function (val) {
        this.options.debug = val;
    },
    destroy: function () {
        /* istanbul ignore if */
        if (this.options.debug) {
            console.log("data_worker - SubscriptionObj: " + this.options.channel_name + " subscription being destroyed.");
        }
        this.unsubscribe();
        this.removeEvents();
        delete OCS.Worker.Subscriptions[this.options.channel_name];
        this.options = {channel_name: null,
            dataset: '',
            debug: false
        };
    }

});